import { NotificationResult } from '@/types';

export const addNotification = (notificationResult: NotificationResult) => ({
    type: 'NOTIFICATION::ADD',
    data: notificationResult,
});

export const addNotifications = (notificationResult: NotificationResult) => ({
    type: 'NOTIFICATION::ADD_MANY',
    data: notificationResult,
});
